import { render, staticRenderFns } from "./LeaveTypes.vue?vue&type=template&id=561e9786&scoped=true&"
import script from "./LeaveTypes.vue?vue&type=script&lang=js&"
export * from "./LeaveTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561e9786",
  null
  
)

export default component.exports